module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('card', {
    attrs: {
      "cardData": {
        title: '各分销商销售情况',
        type: 'table',
        data: _vm.distributorData,
        key: _vm.distributorKey
      }
    },
    on: {
      "pagSearch": _vm.distributorSearch
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d8ef2c0","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/distributorMana/distributorData.vue
// module id = 937
// module chunks = 1